const EvAutocomplete = {
    idMap: 'map',
    idInput: 'location',
    idCountry: 'country_id',
    renderAddress: function(place, marker, map) {
        map.setCenter(place.geometry.location);
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);
    },
    fillInAddress: function(place) {  // optional parameter
        if(process.env.NODE_ENV === "development") {
            console.log(place)
        }
        // const addressNameFormat = {
        //   'street_number': 'short_name',
        //   'route': 'long_name',
        //   'locality': 'long_name',
        //   'administrative_area_level_1': 'short_name',
        //   'country': 'long_name',
        //   'postal_code': 'short_name',
        // };
        // const getAddressComp = function (type) {
        //   for (const component of place.address_components) {
        //     if (component.types[0] === type) {
        //       return component[addressNameFormat[type]];
        //     }
        //   }
        //   return '';
        // };
        // document.getElementById('location').value = getAddressComp('street_number') + ' '
        //           + getAddressComp('route');
        // for (const component of componentForm) {
        //   // Location field is handled separately above as it has different logic.
        //   if (component !== 'location') {
        //     document.getElementById(component).value = getAddressComp(component);
        //   }
        // }
    },
    initMap: function() {
        const center = { lat: 37.4221, lng: -122.0841 };
        const map = new google.maps.Map(document.getElementById(this.idMap), {
            zoom: 11,
            center: center,
            mapTypeControl: false,
            fullscreenControl: false,
            zoomControl: true,
            streetViewControl: false
        });
        const marker = new google.maps.Marker({map: map, draggable: false});

        // [START maps_places_autocomplete_creation]
        // Create a bounding box with sides ~10km away from the center point
        const defaultBounds = {
          north: center.lat + 0.1,
          south: center.lat - 0.1,
          east: center.lng + 0.1,
          west: center.lng - 0.1,
        };
        const input = document.getElementById(this.idInput);
        const options = {
          bounds: defaultBounds,
          componentRestrictions: { country: "it" },
          fields: ["address_components", "geometry", "icon", "name"],
          strictBounds: false,
          types: ["establishment"],
        };
        const autocomplete = new google.maps.places.Autocomplete(input, options);
        autocomplete.addListener('place_changed', function () {
            marker.setVisible(false);
            const place = autocomplete.getPlace();
            if (!place.geometry) {
              // User entered the name of a Place that was not suggested and
              // pressed the Enter key, or the Place Details request failed.
              window.alert('No details available for input: \'' + place.name + '\'');
              return;
            }
            this.renderAddress(place, marker, map);
            this.fillInAddress(place);
          });
        // [END maps_places_autocomplete_creation]

        // Cambio country per ricerca
        // const country = document.getElementById(this.idCountry)
        // country.addEventListener('change', function() {
        //     autocomplete.setComponentRestrictions({ country: country.value })
        // })
    }
}

export default EvAutocomplete
